import {AxiosResponse, AxiosRequestConfig } from 'axios';
import HttpRequest from '@/services/http-request';

export const saveCustomer = (payload: any): Promise<AxiosResponse> => HttpRequest.post('api/customers/update_or_create', payload);

export const customerList = (): Promise<AxiosResponse> => HttpRequest.post('api/customers/list');

export const customerListPaginate = (payload: any): Promise<AxiosResponse> => HttpRequest.post('api/customers/list/paginate', payload);

export const deleteCustomer = (config: AxiosRequestConfig): Promise<AxiosResponse> => HttpRequest.delete('api/customers/delete', config);

export const getCustomer = (config: any): Promise<AxiosResponse> => HttpRequest.get('api/customers', config);
